export default __webpack_public_path__ + "static/media/4.0da2244a.jpg";